export default __webpack_public_path__ + "static/media/icons8-youtube.16c9d3d1.svg";